enum FormName {
  general = "contact",
  imageObjectDetector = "contact-image-object-detector",
  imageObjectDetectorAerial = "contact-image-object-detector-aerial",
  imageClassifier = "contact-image-classifier",
}

export default FormName;
